"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightChevronIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../constants");
/**
 * Standard right chevron icon - https://www.figma.com/file/qPpy550VSNWIx9tBNcZJrG/SDS-WebC-Icons?node-id=1%3A6050
 */
function RightChevronIcon(props) {
    const { className, "data-testid": dataTestId, fill = "#000000", size = constants_1.Sizes.Large } = props;
    return ((0, jsx_runtime_1.jsx)("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, "data-testid": dataTestId, children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.4858 12L7.83289 17.6529L9.2471 19.0671L16.3142 12L9.2471 4.93286L7.83288 6.34708L13.4858 12Z" }) }));
}
exports.RightChevronIcon = RightChevronIcon;
//# sourceMappingURL=RightChevronIcon.js.map